import { Navigate, useLocation } from "react-router-dom";
import { ROUTE } from "../constants/routes";

const LoginRedirect = () => {
  const { search, hash } = useLocation();

  return <Navigate to={{ pathname: ROUTE.SIGNIN, search, hash }} replace />;
};

export default LoginRedirect;
